// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CRYR Portal Theme - CSS Custom Properties
 * 
 * This file contains CSS variables that can be used throughout the application
 * to maintain consistent theming based on the login page design.
 */

:root {
  /* CRYR Brand Colors */
  --cryrDarkBlue: #15243e;
  --cryrLightBlue: #9dd0fb;
  
  /* Primary Colors */
  --color-primary: #4B92DB;
  --color-primary-dark: #3a7bc8;
  --color-primary-light: #6ba3e0;
  
  /* Secondary Colors */
  --color-secondary: #16243E;
  --color-secondary-dark: #0f1a2e;
  --color-secondary-light: #1a2a4a;
  
  /* Text Colors */
  --color-text-primary: #141514;
  --color-text-secondary: #6E726E;
  --color-text-disabled: #4D4D4D;
  --color-text-inverse: #ffffff;
  
  /* Background Colors */
  --color-background-primary: #ffffff;
  --color-background-secondary: #f8f9fa;
  --color-background-dark: #16243E;
  
  /* Border Colors */
  --color-border-primary: #C8C8C8;
  --color-border-focus: #4B92DB;
  --color-border-error: #FC3E63;
  
  /* Status Colors */
  --color-status-success: #28a745;
  --color-status-warning: #ffc107;
  --color-status-error: #FC3E63;
  --color-status-info: #17a2b8;
  
  /* Disabled Colors */
  --color-disabled-background: #6E726E;
  --color-disabled-text: #4D4D4D;
  
  /* Typography */
  --font-family-primary: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  --font-family-mono: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  
  /* Font Sizes */
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;
  --font-size-3xl: 1.875rem;
  --font-size-4xl: 2.25rem;
  
  /* Font Weights */
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  
  /* Line Heights */
  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  --spacing-3xl: 4rem;
  
  /* Border Radius */
  --border-radius-sm: 4px;
  --border-radius-md: 6px;
  --border-radius-lg: 8px;
  --border-radius-xl: 12px;
  --border-radius-full: 9999px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  
  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.2s ease;
  --transition-slow: 0.3s ease;
  
  /* Z-Index */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal: 1040;
  --z-popover: 1050;
  --z-tooltip: 1060;
}

/* Global Base Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-size: var(--font-size-base);
  line-height: 1.5;
  line-height: var(--line-height-normal);
  color: #141514;
  color: var(--color-text-primary);
  background-color: #ffffff;
  background-color: var(--color-background-primary);
  margin: 0;
  padding: 0;
}

/* Utility Classes */
.text-primary { color: #141514; color: var(--color-text-primary); }
.text-secondary { color: #6E726E; color: var(--color-text-secondary); }
.text-disabled { color: #4D4D4D; color: var(--color-text-disabled); }
.text-inverse { color: #ffffff; color: var(--color-text-inverse); }

.bg-primary { background-color: #ffffff; background-color: var(--color-background-primary); }
.bg-secondary { background-color: #f8f9fa; background-color: var(--color-background-secondary); }
.bg-dark { background-color: #16243E; background-color: var(--color-background-dark); }

.border-primary { border-color: #C8C8C8; border-color: var(--color-border-primary); }
.border-focus { border-color: #4B92DB; border-color: var(--color-border-focus); }
.border-error { border-color: #FC3E63; border-color: var(--color-border-error); }

.rounded-sm { border-radius: 4px; border-radius: var(--border-radius-sm); }
.rounded-md { border-radius: 6px; border-radius: var(--border-radius-md); }
.rounded-lg { border-radius: 8px; border-radius: var(--border-radius-lg); }
.rounded-xl { border-radius: 12px; border-radius: var(--border-radius-xl); }
.rounded-full { border-radius: 9999px; border-radius: var(--border-radius-full); }

.shadow-sm { box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); box-shadow: var(--shadow-sm); }
.shadow-md { box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); box-shadow: var(--shadow-md); }
.shadow-lg { box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1); box-shadow: var(--shadow-lg); }
.shadow-xl { box-shadow: 0 20px 25px rgba(0, 0, 0, 0.1); box-shadow: var(--shadow-xl); }

.transition-fast { transition: 0.15s ease; transition: var(--transition-fast); }
.transition-normal { transition: 0.2s ease; transition: var(--transition-normal); }
.transition-slow { transition: 0.3s ease; transition: var(--transition-slow); }

/* Typography Utilities */
.text-xs { font-size: 0.75rem; font-size: var(--font-size-xs); }
.text-sm { font-size: 0.875rem; font-size: var(--font-size-sm); }
.text-base { font-size: 1rem; font-size: var(--font-size-base); }
.text-lg { font-size: 1.125rem; font-size: var(--font-size-lg); }
.text-xl { font-size: 1.25rem; font-size: var(--font-size-xl); }
.text-2xl { font-size: 1.5rem; font-size: var(--font-size-2xl); }
.text-3xl { font-size: 1.875rem; font-size: var(--font-size-3xl); }
.text-4xl { font-size: 2.25rem; font-size: var(--font-size-4xl); }

.font-normal { font-weight: 400; font-weight: var(--font-weight-normal); }
.font-medium { font-weight: 500; font-weight: var(--font-weight-medium); }
.font-semibold { font-weight: 600; font-weight: var(--font-weight-semibold); }
.font-bold { font-weight: 700; font-weight: var(--font-weight-bold); }

.leading-tight { line-height: 1.25; line-height: var(--line-height-tight); }
.leading-normal { line-height: 1.5; line-height: var(--line-height-normal); }
.leading-relaxed { line-height: 1.75; line-height: var(--line-height-relaxed); }

/* Spacing Utilities */
.p-xs { padding: 0.25rem; padding: var(--spacing-xs); }
.p-sm { padding: 0.5rem; padding: var(--spacing-sm); }
.p-md { padding: 1rem; padding: var(--spacing-md); }
.p-lg { padding: 1.5rem; padding: var(--spacing-lg); }
.p-xl { padding: 2rem; padding: var(--spacing-xl); }
.p-2xl { padding: 3rem; padding: var(--spacing-2xl); }
.p-3xl { padding: 4rem; padding: var(--spacing-3xl); }

.m-xs { margin: 0.25rem; margin: var(--spacing-xs); }
.m-sm { margin: 0.5rem; margin: var(--spacing-sm); }
.m-md { margin: 1rem; margin: var(--spacing-md); }
.m-lg { margin: 1.5rem; margin: var(--spacing-lg); }
.m-xl { margin: 2rem; margin: var(--spacing-xl); }
.m-2xl { margin: 3rem; margin: var(--spacing-2xl); }
.m-3xl { margin: 4rem; margin: var(--spacing-3xl); }

/* Data table row striping override */
.rdt_Table .rdt_TableBody .rdt_TableRow:nth-child(odd) {
  background-color: #ffffff !important;
}

.rdt_Table .rdt_TableBody .rdt_TableRow:nth-child(even) {
  background-color: #e1f3ff !important; /* requested light blue */
}

/* Keep a subtle hover without losing stripe */
.rdt_Table .rdt_TableBody .rdt_TableRow:hover {
  filter: brightness(0.98);
}

/* Improve input field borders to match react-select styling (excluding react-select itself) */
.form-control:not(.react-select__input),
input[type="text"]:not(.react-select__input),
input[type="email"]:not(.react-select__input),
input[type="password"]:not(.react-select__input),
input[type="number"]:not(.react-select__input),
input[type="tel"]:not(.react-select__input),
input[type="url"]:not(.react-select__input),
input[type="search"]:not(.react-select__input),
textarea:not(.react-select__input),
select:not(.react-select__input) {
  border: 1px solid #ced4da !important;
  border-radius: 0.375rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

.form-control:not(.react-select__input):focus,
input[type="text"]:not(.react-select__input):focus,
input[type="email"]:not(.react-select__input):focus,
input[type="password"]:not(.react-select__input):focus,
input[type="number"]:not(.react-select__input):focus,
input[type="tel"]:not(.react-select__input):focus,
input[type="url"]:not(.react-select__input):focus,
input[type="search"]:not(.react-select__input):focus,
textarea:not(.react-select__input):focus,
select:not(.react-select__input):focus {
  border-color: #2684ff !important;
  box-shadow: 0 0 0 1px #2684ff !important;
  outline: none !important;
}

/* Notification Bell Badge Positioning */
.iconClass {
  position: relative;
  display: inline-block;
  height: 40px;
  width: 40px;
  overflow: visible;
}

.iconClass span {
  position: absolute;
  top: -8px;
  right: -8px;
  display: block;
  z-index: 10;
}

/* Override Bootstrap badge margin for notification bell */
.iconClass .badge {
  margin-left: -15px !important;
  margin-right: 0px !important;
  margin-top: -15px !important;
  margin-bottom: 0px !important;
}

/* Notification dropdown width - higher specificity */
.dropdown-menu.notification-dropdown {
  min-width: 350px !important;
  max-height: 500px !important;
  overflow-y: auto !important;
}

/* Data Table Header Alignment - Global Styles */
.header-center {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  padding: 0 8px !important;
}

.header-right {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  width: 100% !important;
  padding: 0 0px !important;
}

.header-left {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  width: 100% !important;
  padding: 0 0px !important;
}

/* Ensure text cursor behavior in data table cells - only affect cursor, not other styles */
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell span,
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div span {
  cursor: text !important;
}

/* Ensure copyable cells maintain text cursor */
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .d-flex span {
  cursor: text !important;
}

/* Ensure cell alignment wrappers maintain their padding */
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {
  padding: 0 18px !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme/theme.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;;EAExB,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;;EAE9B,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;;EAEhC,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;;EAE7B,sBAAsB;EACtB,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;;EAEhC,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;;EAE7B,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;;EAE5B,oBAAoB;EACpB,oCAAoC;EACpC,8BAA8B;;EAE9B,eAAe;EACf,wKAAwK;EACxK,4FAA4F;;EAE5F,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;;EAE5B,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;;EAE3C,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;;EAE5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;AACxB;;AAEA;EACE,8JAAuC;EAAvC,uCAAuC;EACvC,eAAgC;EAAhC,gCAAgC;EAChC,gBAAsC;EAAtC,sCAAsC;EACtC,cAAgC;EAAhC,gCAAgC;EAChC,yBAAiD;EAAjD,iDAAiD;EACjD,SAAS;EACT,UAAU;AACZ;;AAEA,oBAAoB;AACpB,gBAAgB,cAAgC,EAAhC,gCAAgC,EAAE;AAClD,kBAAkB,cAAkC,EAAlC,kCAAkC,EAAE;AACtD,iBAAiB,cAAiC,EAAjC,iCAAiC,EAAE;AACpD,gBAAgB,cAAgC,EAAhC,gCAAgC,EAAE;;AAElD,cAAc,yBAAiD,EAAjD,iDAAiD,EAAE;AACjE,gBAAgB,yBAAmD,EAAnD,mDAAmD,EAAE;AACrE,WAAW,yBAA8C,EAA9C,8CAA8C,EAAE;;AAE3D,kBAAkB,qBAAyC,EAAzC,yCAAyC,EAAE;AAC7D,gBAAgB,qBAAuC,EAAvC,uCAAuC,EAAE;AACzD,gBAAgB,qBAAuC,EAAvC,uCAAuC,EAAE;;AAEzD,cAAc,kBAAsC,EAAtC,sCAAsC,EAAE;AACtD,cAAc,kBAAsC,EAAtC,sCAAsC,EAAE;AACtD,cAAc,kBAAsC,EAAtC,sCAAsC,EAAE;AACtD,cAAc,mBAAsC,EAAtC,sCAAsC,EAAE;AACtD,gBAAgB,qBAAwC,EAAxC,wCAAwC,EAAE;;AAE1D,aAAa,yCAA4B,EAA5B,4BAA4B,EAAE;AAC3C,aAAa,wCAA4B,EAA5B,4BAA4B,EAAE;AAC3C,aAAa,0CAA4B,EAA5B,4BAA4B,EAAE;AAC3C,aAAa,0CAA4B,EAA5B,4BAA4B,EAAE;;AAE3C,mBAAmB,sBAAkC,EAAlC,kCAAkC,EAAE;AACvD,qBAAqB,qBAAoC,EAApC,oCAAoC,EAAE;AAC3D,mBAAmB,qBAAkC,EAAlC,kCAAkC,EAAE;;AAEvD,yBAAyB;AACzB,WAAW,kBAA8B,EAA9B,8BAA8B,EAAE;AAC3C,WAAW,mBAA8B,EAA9B,8BAA8B,EAAE;AAC3C,aAAa,eAAgC,EAAhC,gCAAgC,EAAE;AAC/C,WAAW,mBAA8B,EAA9B,8BAA8B,EAAE;AAC3C,WAAW,kBAA8B,EAA9B,8BAA8B,EAAE;AAC3C,YAAY,iBAA+B,EAA/B,+BAA+B,EAAE;AAC7C,YAAY,mBAA+B,EAA/B,+BAA+B,EAAE;AAC7C,YAAY,kBAA+B,EAA/B,+BAA+B,EAAE;;AAE7C,eAAe,gBAAsC,EAAtC,sCAAsC,EAAE;AACvD,eAAe,gBAAsC,EAAtC,sCAAsC,EAAE;AACvD,iBAAiB,gBAAwC,EAAxC,wCAAwC,EAAE;AAC3D,aAAa,gBAAoC,EAApC,oCAAoC,EAAE;;AAEnD,iBAAiB,iBAAqC,EAArC,qCAAqC,EAAE;AACxD,kBAAkB,gBAAsC,EAAtC,sCAAsC,EAAE;AAC1D,mBAAmB,iBAAuC,EAAvC,uCAAuC,EAAE;;AAE5D,sBAAsB;AACtB,QAAQ,gBAA0B,EAA1B,0BAA0B,EAAE;AACpC,QAAQ,eAA0B,EAA1B,0BAA0B,EAAE;AACpC,QAAQ,aAA0B,EAA1B,0BAA0B,EAAE;AACpC,QAAQ,eAA0B,EAA1B,0BAA0B,EAAE;AACpC,QAAQ,aAA0B,EAA1B,0BAA0B,EAAE;AACpC,SAAS,aAA2B,EAA3B,2BAA2B,EAAE;AACtC,SAAS,aAA2B,EAA3B,2BAA2B,EAAE;;AAEtC,QAAQ,eAAyB,EAAzB,yBAAyB,EAAE;AACnC,QAAQ,cAAyB,EAAzB,yBAAyB,EAAE;AACnC,QAAQ,YAAyB,EAAzB,yBAAyB,EAAE;AACnC,QAAQ,cAAyB,EAAzB,yBAAyB,EAAE;AACnC,QAAQ,YAAyB,EAAzB,yBAAyB,EAAE;AACnC,SAAS,YAA0B,EAA1B,0BAA0B,EAAE;AACrC,SAAS,YAA0B,EAA1B,0BAA0B,EAAE;;AAErC,qCAAqC;AACrC;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC,EAAE,yBAAyB;AACjE;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;AAC1B;;AAEA,8FAA8F;AAC9F;;;;;;;;;;EAUE,oCAAoC;EACpC,kCAAkC;EAClC,mFAAmF;AACrF;;AAEA;;;;;;;;;;EAUE,gCAAgC;EAChC,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,2FAA2F;AAC3F;;EAEE,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,0BAA0B;AAC5B","sourcesContent":["/**\n * CRYR Portal Theme - CSS Custom Properties\n * \n * This file contains CSS variables that can be used throughout the application\n * to maintain consistent theming based on the login page design.\n */\n\n:root {\n  /* CRYR Brand Colors */\n  --cryrDarkBlue: #15243e;\n  --cryrLightBlue: #9dd0fb;\n  \n  /* Primary Colors */\n  --color-primary: #4B92DB;\n  --color-primary-dark: #3a7bc8;\n  --color-primary-light: #6ba3e0;\n  \n  /* Secondary Colors */\n  --color-secondary: #16243E;\n  --color-secondary-dark: #0f1a2e;\n  --color-secondary-light: #1a2a4a;\n  \n  /* Text Colors */\n  --color-text-primary: #141514;\n  --color-text-secondary: #6E726E;\n  --color-text-disabled: #4D4D4D;\n  --color-text-inverse: #ffffff;\n  \n  /* Background Colors */\n  --color-background-primary: #ffffff;\n  --color-background-secondary: #f8f9fa;\n  --color-background-dark: #16243E;\n  \n  /* Border Colors */\n  --color-border-primary: #C8C8C8;\n  --color-border-focus: #4B92DB;\n  --color-border-error: #FC3E63;\n  \n  /* Status Colors */\n  --color-status-success: #28a745;\n  --color-status-warning: #ffc107;\n  --color-status-error: #FC3E63;\n  --color-status-info: #17a2b8;\n  \n  /* Disabled Colors */\n  --color-disabled-background: #6E726E;\n  --color-disabled-text: #4D4D4D;\n  \n  /* Typography */\n  --font-family-primary: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  --font-family-mono: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  \n  /* Font Sizes */\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n  --font-size-3xl: 1.875rem;\n  --font-size-4xl: 2.25rem;\n  \n  /* Font Weights */\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  \n  /* Line Heights */\n  --line-height-tight: 1.25;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n  --spacing-3xl: 4rem;\n  \n  /* Border Radius */\n  --border-radius-sm: 4px;\n  --border-radius-md: 6px;\n  --border-radius-lg: 8px;\n  --border-radius-xl: 12px;\n  --border-radius-full: 9999px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);\n  \n  /* Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.2s ease;\n  --transition-slow: 0.3s ease;\n  \n  /* Z-Index */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal: 1040;\n  --z-popover: 1050;\n  --z-tooltip: 1060;\n}\n\n/* Global Base Styles */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-normal);\n  color: var(--color-text-primary);\n  background-color: var(--color-background-primary);\n  margin: 0;\n  padding: 0;\n}\n\n/* Utility Classes */\n.text-primary { color: var(--color-text-primary); }\n.text-secondary { color: var(--color-text-secondary); }\n.text-disabled { color: var(--color-text-disabled); }\n.text-inverse { color: var(--color-text-inverse); }\n\n.bg-primary { background-color: var(--color-background-primary); }\n.bg-secondary { background-color: var(--color-background-secondary); }\n.bg-dark { background-color: var(--color-background-dark); }\n\n.border-primary { border-color: var(--color-border-primary); }\n.border-focus { border-color: var(--color-border-focus); }\n.border-error { border-color: var(--color-border-error); }\n\n.rounded-sm { border-radius: var(--border-radius-sm); }\n.rounded-md { border-radius: var(--border-radius-md); }\n.rounded-lg { border-radius: var(--border-radius-lg); }\n.rounded-xl { border-radius: var(--border-radius-xl); }\n.rounded-full { border-radius: var(--border-radius-full); }\n\n.shadow-sm { box-shadow: var(--shadow-sm); }\n.shadow-md { box-shadow: var(--shadow-md); }\n.shadow-lg { box-shadow: var(--shadow-lg); }\n.shadow-xl { box-shadow: var(--shadow-xl); }\n\n.transition-fast { transition: var(--transition-fast); }\n.transition-normal { transition: var(--transition-normal); }\n.transition-slow { transition: var(--transition-slow); }\n\n/* Typography Utilities */\n.text-xs { font-size: var(--font-size-xs); }\n.text-sm { font-size: var(--font-size-sm); }\n.text-base { font-size: var(--font-size-base); }\n.text-lg { font-size: var(--font-size-lg); }\n.text-xl { font-size: var(--font-size-xl); }\n.text-2xl { font-size: var(--font-size-2xl); }\n.text-3xl { font-size: var(--font-size-3xl); }\n.text-4xl { font-size: var(--font-size-4xl); }\n\n.font-normal { font-weight: var(--font-weight-normal); }\n.font-medium { font-weight: var(--font-weight-medium); }\n.font-semibold { font-weight: var(--font-weight-semibold); }\n.font-bold { font-weight: var(--font-weight-bold); }\n\n.leading-tight { line-height: var(--line-height-tight); }\n.leading-normal { line-height: var(--line-height-normal); }\n.leading-relaxed { line-height: var(--line-height-relaxed); }\n\n/* Spacing Utilities */\n.p-xs { padding: var(--spacing-xs); }\n.p-sm { padding: var(--spacing-sm); }\n.p-md { padding: var(--spacing-md); }\n.p-lg { padding: var(--spacing-lg); }\n.p-xl { padding: var(--spacing-xl); }\n.p-2xl { padding: var(--spacing-2xl); }\n.p-3xl { padding: var(--spacing-3xl); }\n\n.m-xs { margin: var(--spacing-xs); }\n.m-sm { margin: var(--spacing-sm); }\n.m-md { margin: var(--spacing-md); }\n.m-lg { margin: var(--spacing-lg); }\n.m-xl { margin: var(--spacing-xl); }\n.m-2xl { margin: var(--spacing-2xl); }\n.m-3xl { margin: var(--spacing-3xl); }\n\n/* Data table row striping override */\n.rdt_Table .rdt_TableBody .rdt_TableRow:nth-child(odd) {\n  background-color: #ffffff !important;\n}\n\n.rdt_Table .rdt_TableBody .rdt_TableRow:nth-child(even) {\n  background-color: #e1f3ff !important; /* requested light blue */\n}\n\n/* Keep a subtle hover without losing stripe */\n.rdt_Table .rdt_TableBody .rdt_TableRow:hover {\n  filter: brightness(0.98);\n}\n\n/* Improve input field borders to match react-select styling (excluding react-select itself) */\n.form-control:not(.react-select__input),\ninput[type=\"text\"]:not(.react-select__input),\ninput[type=\"email\"]:not(.react-select__input),\ninput[type=\"password\"]:not(.react-select__input),\ninput[type=\"number\"]:not(.react-select__input),\ninput[type=\"tel\"]:not(.react-select__input),\ninput[type=\"url\"]:not(.react-select__input),\ninput[type=\"search\"]:not(.react-select__input),\ntextarea:not(.react-select__input),\nselect:not(.react-select__input) {\n  border: 1px solid #ced4da !important;\n  border-radius: 0.375rem !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n\n.form-control:not(.react-select__input):focus,\ninput[type=\"text\"]:not(.react-select__input):focus,\ninput[type=\"email\"]:not(.react-select__input):focus,\ninput[type=\"password\"]:not(.react-select__input):focus,\ninput[type=\"number\"]:not(.react-select__input):focus,\ninput[type=\"tel\"]:not(.react-select__input):focus,\ninput[type=\"url\"]:not(.react-select__input):focus,\ninput[type=\"search\"]:not(.react-select__input):focus,\ntextarea:not(.react-select__input):focus,\nselect:not(.react-select__input):focus {\n  border-color: #2684ff !important;\n  box-shadow: 0 0 0 1px #2684ff !important;\n  outline: none !important;\n}\n\n/* Notification Bell Badge Positioning */\n.iconClass {\n  position: relative;\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n  overflow: visible;\n}\n\n.iconClass span {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  display: block;\n  z-index: 10;\n}\n\n/* Override Bootstrap badge margin for notification bell */\n.iconClass .badge {\n  margin-left: -15px !important;\n  margin-right: 0px !important;\n  margin-top: -15px !important;\n  margin-bottom: 0px !important;\n}\n\n/* Notification dropdown width - higher specificity */\n.dropdown-menu.notification-dropdown {\n  min-width: 350px !important;\n  max-height: 500px !important;\n  overflow-y: auto !important;\n}\n\n/* Data Table Header Alignment - Global Styles */\n.header-center {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  width: 100% !important;\n  padding: 0 8px !important;\n}\n\n.header-right {\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  width: 100% !important;\n  padding: 0 0px !important;\n}\n\n.header-left {\n  display: flex !important;\n  justify-content: flex-start !important;\n  align-items: center !important;\n  width: 100% !important;\n  padding: 0 0px !important;\n}\n\n/* Ensure text cursor behavior in data table cells - only affect cursor, not other styles */\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell span,\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div span {\n  cursor: text !important;\n}\n\n/* Ensure copyable cells maintain text cursor */\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .d-flex span {\n  cursor: text !important;\n}\n\n/* Ensure cell alignment wrappers maintain their padding */\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {\n  padding: 0 18px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
